import { Controller } from "@hotwired/stimulus"

// Mirrors a title field into a slug field, but only while the slug is
// "untouched" — once the user types into the slug input themselves we
// stop overriding it. Used by pages wizard step 3.
//
// Markup:
//   <div data-controller="slug-sync">
//     <input data-slug-sync-target="title" type="text">
//     <input data-slug-sync-target="slug" type="text">
//   </div>
export default class extends Controller {
  static targets = ["title", "slug"]

  connect() {
    // The slug is considered "untouched" only if it's empty on initial
    // render. If the user already has a custom slug, we never auto-sync.
    this.userTouched = this.slugTarget.value.trim().length > 0
    this.titleTarget.addEventListener("input", this.handleTitle.bind(this))
    this.slugTarget.addEventListener("input", this.handleSlug.bind(this))
  }

  handleTitle() {
    if (this.userTouched) return
    this.slugTarget.value = this.#slugify(this.titleTarget.value)
  }

  handleSlug() {
    // First keystroke in the slug field counts as user-claiming it,
    // unless they clear it back to empty.
    this.userTouched = this.slugTarget.value.trim().length > 0
  }

  #slugify(value) {
    return String(value)
      .toLowerCase()
      .normalize("NFKD")
      .replace(/[̀-ͯ]/g, "")  // strip accents
      .replace(/[^a-z0-9\s\-]/g, "")    // drop anything that isn't slug-safe
      .trim()
      .replace(/\s+/g, "-")              // spaces → tirets
      .replace(/\-+/g, "-")              // collapse runs of dashes
  }
}
